







import { Prop, Component, Vue } from 'vue-property-decorator'
import { OrderStatus } from '@/api/types'
import { isEqual } from 'lodash'
import { namespace } from 'vuex-class'
const orders = namespace('orders')

@Component
export default class OrderStatusTab extends Vue {
    @orders.State readonly statusFilter!: string
    @orders.Action applyStatusFilter: ({ statusFilter: string }) => Promise<void>
    @Prop({ required: true }) readonly title!: string
    @Prop({ required: true }) readonly status!: string
    @Prop({ required: true }) readonly count!: number

    setActive(): void {
        if (isEqual(this.statusFilter, this.status)) {
            return
        }

        this.applyStatusFilter({
            statusFilter: this.status,
        })
    }

    colorForStatus(status: string, opacity: number = 1): string {
        switch (status) {
            case OrderStatus.PENDING: return `rgba(247, 131, 35, ${opacity})`
            case OrderStatus.SUCCESSFUL: return `rgba(19, 210, 197, ${opacity})`
            case OrderStatus.UNSUCCESSFUL: return `rgba(235, 89, 140, ${opacity})`
            default: return `rgba(169, 50, 38, ${opacity})`
        }
    }

    get classForStatus(): object {
        return {
            'order-status-tab--active': this.status === this.statusFilter,
        }
    }

    get countStyleForStatus() {
        return {
            'background-color': this.colorForStatus(this.status, .25),
            'color': this.colorForStatus(this.status),
        }
    }
}
